<template>
  <v-dialog v-model="dialogOpen"
    v-if="dialogOpen"
    content-class="my-custom-dialog"
    transition="slide-x-transition"
    persistent
    max-width="1200"
    @keydown.esc="close">
    <v-card tile
      color="white"
      style="border-radius: 25px !important">
      <v-card-title class="d-flex"
        style="
              vertical-align: middle;
              background-color: #1577da;

              height: 58px;
              color: white;
            ">
        <h2>{{ $t("$vuetify.tables.tables") }}</h2>
      </v-card-title>
      <v-card-text class="white pa-0"> <!-- Removed padding -->
        <v-tabs v-model="activeTab"
          color="primary"
          class="custom-tabs"
          grow>
          <v-tab key="existing">{{ $t("Zauzeti") }}</v-tab>
          <v-tab key="new">{{ $t("Slobodni") }}</v-tab>
        </v-tabs>

        <v-tabs-items class="pr-10 pl-10"
          v-model="activeTab">
          <v-tab-item class="pt-0 mt-0"
            key="existing">
            <v-container class="panel-container">
              <v-row>
                <v-col v-for="(table, idxc) in userTables"
                  :key="idxc"
                  :cols="3"
                  class="panel-cell"
                  align="center">
                  <v-btn :disabled="tableLocked(table) || isProcessing"
                    block
                    tile
                    depressed
                    min-height="3.5rem"
                    color="primary"
                    return-object
                    style="border-radius: 12px"
                    @click="onCellClick(table)">
                    <span class="white--text tile btn-lg">{{ table.name }}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- New Tables Tab -->
          <v-tab-item class="pt-0 mt-0"
            key="new">
            <v-container class="panel-container">
              <v-row>
                <v-col v-for="(table, idxc) in newTables"
                  :key="idxc"
                  :cols="3"
                  class="panel-cell"
                  align="center">
                  <v-btn :disabled="tableLocked(table) || isProcessing"
                    block
                    tile
                    depressed
                    min-height="3.5rem"
                    color="primary"
                    return-object
                    style="border-radius: 12px"
                    @click="onCellClick(table)">
                    <span class="white--text tile btn-lg">{{ table.name }}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions class="d-flex pt-2 mt-0 pr-12 justify-end">
        <v-btn @click="close"
          :disabled="isProcessing"
          class="btn dangerButton">
          Odustani
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import state from '@/state'
import { clone } from '@/plugins/utils'
import EventBus from '@/plugins/event-bus'

export default {
  inject: ['confirm', 'confirmClose'],
  data () {
    return {
      dialogOpen: false,
      isProcessing: false, // Za prikaz loading overlay-a
      persist: true,
      addTableDialogOpen: false,
      table: {},
      sourceTable: {},
      destinationTable: {},
      userTables: [],
      newTables: [],
      activeTab: 'existing' // Initialize the active tab
    }
  },
  props: {
    availableTables: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    open (sourceTable, destinationTable) {
      this.sourceTable = sourceTable
      this.destinationTable = destinationTable

      // Kreiraj kopiju availableTables i ukloni source stol da se ne može odabrati isti stol
      const filteredTables = this.availableTables.filter(t => t.id !== sourceTable.id)
      this.userTables = clone(filteredTables)

      // Filter new (empty) tables
      this.newTables = this.userTables.filter(
        (table) => !table.items || table.items.length === 0
      )

      // Show all occupied tables (remove user filtering)
      this.userTables = this.userTables.filter(
        (table) => table.items && table.items.length > 0
      )

      // Sort both lists by table name
      this.userTables.sort((a, b) => {
        const nameA = (a.name || '').toString().toLowerCase()
        const nameB = (b.name || '').toString().toLowerCase()
        return nameA.localeCompare(nameB)
      })

      this.newTables.sort((a, b) => {
        const nameA = (a.name || '').toString().toLowerCase()
        const nameB = (b.name || '').toString().toLowerCase()
        return nameA.localeCompare(nameB)
      })

      this.dialogOpen = true
    },
    close () {
      this.dialogOpen = false
    },
    tableLocked (table) {
      return table.locked && table.locked_by !== state.getUser().id
    },
    onCloseAddTableDialog () {
      this.addTableDialogOpen = false
    },
    onCellClick (targetTable) {
      // ✅ 1. Early return
      if (this.isProcessing) {
        console.warn('⚠️ Transfer već u tijeku')
        return
      }

      // ✅ 2. FLAG PRIJE modifikacija
      this.isProcessing = true
      console.log('SelectTable2: Započinjem transfer')

      // ✅ 3. Modifikacije sa clone()
      this.destinationTable.items.forEach((item) => {
        if (targetTable.items) {
          const existingItem = targetTable.items.find((i) => i.id === item.id)

          if (existingItem) {
            existingItem.quantity += item.quantity
            existingItem.total += item.discountedUnitPrice * item.quantity
          } else {
            // ✅ KORISTI CLONE
            const clonedItem = clone(item)
            targetTable.items.push(clonedItem)

            const idx = this.sourceTable.items.findIndex((x) => x.id === item.id)
            if (idx > -1) {
              this.sourceTable.items[idx].quantity -= item.quantity
            }
          }
        } else {
          // ✅ KORISTI CLONE
          const clonedItem = clone(item)
          targetTable.items = [clonedItem]

          const idx = this.sourceTable.items.findIndex((x) => x.id === item.id)
          if (idx > -1) {
            this.sourceTable.items[idx].quantity -= item.quantity
          }
        }
      })

      // ✅ 4. Emit event
      console.log('SelectTable2: Emitiram addItemsToTable event')
      this.$emit('addItemsToTable', this.sourceTable, targetTable, this.destinationTable.items)
      console.log('SelectTable2: NE zatvaram dialog - čekam table-transfer-completed event')
      // NE zatvaraj odmah - zatvorit će se preko EventBus eventa
    }
  },
  created () {
    // Slušaj event za zatvaranje nakon transfera
    EventBus.$on('table-transfer-completed', () => {
      console.log('SelectTable2: Primio table-transfer-completed event')
      this.isProcessing = false
      console.log('SelectTable2: Resetirao isProcessing na false, zatvaram dialog')
      this.close()
    })
  },
  beforeDestroy () {
    // Očisti listener
    EventBus.$off('table-transfer-completed')
  }
}
</script>

<style scoped>
/* ... (style ostaje isti) ... */
.v-dialog__content>>>.my-custom-dialog {
  position: absolute;
  top: 50px;
}

.panel-container {
  height: 100%;
  padding: 16px;
  overflow-y: auto;
  overflow-x: hidden;
}

.text-wrap {
  width: min-content;
  margin: auto;
}

.panel-cell {
  padding: 0 2px 2px 0;
}

.active {
  background-color: var(--v-accent-darken3);
  color: white;
}

.label {
  font-size: 0.6rem;
  color: white;
  min-width: 90px;
}

.btn-md {
  font-size: 0.8rem;
  font-weight: 700;
}

.btn-lg {
  font-size: 1.2rem;
  font-weight: 700;
}

/* Custom styling for the tabs */
.custom-tabs>>>.v-tab {
  text-transform: none;
  /* Remove uppercase transformation */
  font-weight: bold;
  /* Make tab labels bold */
  font-size: 1rem;
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.custom-tabs>>>.v-tab--active {
  background-color: #1577da;
  /* Promijenjena boja */
  color: white;
}

.custom-tabs>>>.v-tab:not(.v-tab--active) {
  color: #2c5a90;
}

.custom-tabs>>>.v-tabs-slider {
  background-color: #2c5a90;
}

.v-dialog>.v-card {
  /* Target the card directly inside the dialog */
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  /* Optional: Limit overall dialog height if needed */
  overflow: hidden;
  /* Prevent card itself from scrolling */
}

.v-card__text {
  /* Target v-card-text */
  flex: 1 1 auto;
  /* Allow it to grow and shrink */
  overflow: auto;
  /* Hide overflow, children will handle scroll */
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  /* Ensure no padding interferes */
}

.v-tabs-items {
  flex: 1 1 auto;
  /* Allow tabs-items to grow */
  overflow: auto;
  /* Hide its own overflow */
}

.v-tab-item {
  /* Ensure tab item takes full height */
  height: 100%;
}
</style>
